import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useChats({
  environment, userId,
}) {
  const [chats, setChats] = useState(null);

  useEffect(() => {
    axios
      .get(`${gon.ai_rest_api_base_url}/v1/chat/list`, {
        params: {
          environment,
          user_id: userId,
        },
      })
      .then((response) => {
        setChats(response.data);
      });
  }, []);

  return chats;
}
